import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { type TefComsConsent } from '@src/components/tef-coms-consent.js';
import { doToggle, localDate, localTime } from '@src/components/templates/util.js';
import { ConsentType } from '@src/types/common.js';

export const consentTemplate = (
  consentClasses: string[],
  _checkboxClasses: string[],
  consent: ConsentType,
  disabled: boolean,
  comsConsent: TefComsConsent,
) => {
  const iconType = consent.granted ? 'check' : 'cancel';
  const shouldDisplayLastChange = consent.clientDisplay && localDate(consent.date);

  const lastChangeAtHtml = html`
    <one-list-item size="xs">
      <one-icon name="clock" variant="outline" slot="icon"></one-icon>
      <one-content>
        <one-text size="xs"> Letzte Änderung am
          ${localDate(consent.date)} um ${localTime(consent.date)} Uhr über ${consent.clientDisplay}
        </one-text>
      </one-content>
    </one-list-item>`;

  const iconHtml = html`
    <one-list icon="${iconType}" size="lg">
      <one-list-item>
        <one-icon name="${iconType}" size="lg" variant="outline" slot="icon"></one-icon>
        <one-content>${unsafeHTML(consent.scope)}</one-content>
        ${comsConsent.features}
      </one-list-item>
    </one-list>`;

  const checkboxHtml = html`
      <one-cluster y="start" gap="xxs" no-wrap>
        <one-checkbox
          .checked=${consent.granted}
          @change="${doToggle({ id: consent.id })}"
          id="${consent.id}"
          name="${consent.id}"
          variant="outline"
        ></one-checkbox>
        <one-stack gap="sm">
          <one-content>
            ${unsafeHTML(consent.scope)}
          </one-content>
          ${comsConsent.features}
        </one-stack>
      </one-cluster>`;

  let consentHtml;
  if (disabled) {
    consentHtml = iconHtml;
  } else if (comsConsent.isDisplayModeText() || comsConsent.isDisplayModeList()) {
    consentHtml = html`<one-stack gap="sm">
      <one-content>
        ${unsafeHTML(consent.scope)}
      </one-content>
      ${comsConsent.features}
    </one-stack>`;
  } else {
    consentHtml = checkboxHtml;
  }

  return html`
    <one-stack gap="xs">
      <div class="${consentClasses.join(' ')}">
        ${consent.hintBefore ? html`<div class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</div>` : nothing}
        <one-stack gap="${!disabled ? 'xs' : 'none'}">
          ${consentHtml}
          ${shouldDisplayLastChange ? lastChangeAtHtml : nothing}
          ${consent.hintAfter ? html`
          <one-text as="div" class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</one-text>` : nothing}
        </one-stack>
      </div>
    </one-stack>
    <style>.form-row--group { border: 1px solid; padding: 16px; }</style>`;
};
